import script from "./LinkedTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkedTasks.vue?vue&type=script&setup=true&lang=js"

import "./LinkedTasks.vue?vue&type=style&index=0&id=db593af6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db593af6"]])

export default __exports__